import * as Yup from 'yup'
import { EXTRA, MAIN } from './MembershipType'

export const INITIAL_VALUES = {
  name: ''
}

export const createValidationSchema = () =>
  Yup.object().shape({
    name: Yup.string()
      .required()
      .max(100)
  })

export function toFormValues (group) {
  const { name } = group
  return ({ name })
}

export const membersEmptyState = { main: [], extra: [] }

export function mapMembersToMainAndExtra (members) {
  return {
    main: members.filter(member => member.membershipType === MAIN),
    extra: members.filter(member => member.membershipType === EXTRA)
  }
}
